var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_vm._t("default"),_c('div',{staticClass:"w-full bg-white"},[(Object.keys(_vm.ThemeStore.partners).length > 0)?_c('Footer',{staticClass:"home py-5"}):_vm._e()],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }